export default __webpack_public_path__ + "static/media/redirect_course.34f2def2.svg";